import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {PaymentPlanModel} from '../common/PaymentPlan/PaymentPlan.model';
import type {ProgramDurationModel} from '../common/ProgramDuration/ProgramDuration.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'EditionModel';

export class EditionModel extends BaseModel {
  duration: ProgramDurationModel;
  isAutoRestarting: boolean;
  paymentPlan: Nullable<PaymentPlanModel>;
  programId: string;
  status: EditionModel.Status;
  title: string;

  constructor(props: EditionModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<EditionModel, EditionModel.Props>(props),
    );
  }

  get isEvergreen() {
    return this.isAutoRestarting;
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace EditionModel {
  export type Props = BaseModel.ModelToProps<EditionModel, 'isEvergreen'>;

  export type Status = 'active' | 'archived' | 'draft';
}
